import { Gender, constants } from '../../../..';
import { genderMapping } from '../../mappings/gender';

export const getGenderName = (gender: Gender): string => {
    const mappedGender = Object.entries(genderMapping).find(([, value]) => value === gender)?.[0];

    return mappedGender || constants.NOT_FOUND;
};
